<template>
  <div class="more-actions">
    <b-button variant="danger" href="https://findfood.hungerfreeamerica.org" target="_blank">
      Find Food
    </b-button>
    <b-button variant="outline-danger" :href="`/${language}/nyc`">
      HFA NYC
    </b-button>
    <b-button variant="outline-danger" href="https://bit.ly/4eDe27l" target="_blank">
      Donate
    </b-button>
    <b-button variant="outline-danger" href="https://volunteer.hungerfreeamerica.org" target="_blank">
      Volunteer
    </b-button>
    <b-button variant="outline-primary"
              :to="`/${language}/search`" aria-label="search">
      <Icon type="Search" />
    </b-button>
<!--    <b-sidebar id="donation-sidebar" right shadow width="25rem" bg-variant="white">-->
<!--      <div class="sidebar-contents">-->
<!--&lt;!&ndash;        <b-img src="https://images.prismic.io/hfa-website/ZhVrOzjCgu4jztYD_SpringGiving-1-.png?auto=format,compress" fluid rounded="top"/>&ndash;&gt;-->
<!--        <div id="8xIxhxVllzINgIYriU020" classy="716156" />-->
<!--      </div>-->
<!--    </b-sidebar>-->
  </div>
</template>

<script>
export default {
  name: "MoreActions",
  computed: {
    donateButton() {
      return this.header && this.header.donate_button ? this.header.donate_button : 'Donate'
    },
    volunteerButton() {
      return this.header && this.header.volunteer_button ? this.header.volunteer_button : 'Volunteer'
    },
    findFoodButton() {
      return this.header && this.header.donate_button ? this.header.donate_button : 'Find food'
    },
    nycButton() {
      return this.header && this.header.nyc_button ? this.header.nyc_button : 'HFA NYC'
    },
  },
};
</script>
<style scoped lang="scss">
.more-actions {
    @include grid-h;

    .sidebar & {
        padding: 1rem;
        @include grid-v;
        justify-content: stretch;
    }
    .sidebar-contents{
    }
}
</style>
